import { fromJS } from 'immutable';
import { RSAA } from 'redux-api-middleware';
import {
	API_CONTACT_FORM,
	FORM,
	CONTACT_FORM,
	START,
	SUCCESS,
	ERROR,
} from 'store/constants';

export const handleFormSubmit = params => dispatch => (
	dispatch({
		[RSAA]: {
			endpoint: API_CONTACT_FORM,
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			types: [
				FORM + START,
				FORM + SUCCESS,
				FORM + ERROR,
			],
			body: JSON.stringify(params)
		}
	})
);

const defaultState = fromJS({
	[CONTACT_FORM]: {
		isFormPending: false,
		submitSuccess: false,
		submitError: false,
	}
});

export default function formsReducer(state = defaultState, action) {
	const { type } = action;
	switch (type) {
		case FORM + START:
			return state.setIn([CONTACT_FORM, 'isFormPending'], true);
		case FORM + SUCCESS:
			return state
				.setIn([CONTACT_FORM, 'isFormPending'], false)
				.setIn([CONTACT_FORM, 'submitSuccess'], true)
				.setIn([CONTACT_FORM, 'submitError'], false);
		case FORM + ERROR:
			return state
				.setIn([CONTACT_FORM, 'isFormPending'], false)
				.setIn([CONTACT_FORM, 'submitSuccess'], false)
				.setIn([CONTACT_FORM, 'submitError'], true);
		default:
			return state;
	}
}

export const actionCreators = {
	handleFormSubmit
};
